import { createAction, props } from '@ngrx/store';

import { TravelZoneAddRequest, TravelZoneEditRequest, TravelZoneGetRequest } from '@dave/types';
import { TravelZoneEntity } from '../../entities/travel-zone.entity';
import { GatewayResponseErrorType } from '../../services/app-gateway.service';
import { UploadActionProps } from '../../guards/resolver.helper';

const prefix = 'data/' + 'travel-zone/';
export const TravelZoneActionTypes = {
    LoadRequest: createAction(prefix + 'load/request', props< UploadActionProps >()),
    LoadSuccess: createAction(prefix + 'load/success', props<{ Payload: TravelZoneEntity[], updateLatestUpdatedAt: boolean }>()),
    LoadFailure: createAction(prefix + 'load/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),

    AddRequest: createAction(prefix + 'add/request', props<{ Payload: TravelZoneAddRequest }>()),
    AddSuccess: createAction(prefix + 'add/success', props<{ Payload: TravelZoneEntity }>()),
    AddFailure: createAction(prefix + 'add/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),

    ChangeRequest: createAction(prefix + 'change/request', props<{ Payload: TravelZoneEditRequest }>()),
    ChangeSuccess: createAction(prefix + 'change/success', props<{ Payload: TravelZoneEntity }>()),
    ChangeFailure: createAction(prefix + 'change/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),
};
